import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import NiceModal from '@ebay/nice-modal-react';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import { differenceInDays, endOfDay, isBefore, isWithinInterval, startOfDay } from 'date-fns';
import { none } from 'ramda';
import { isNilOrEmpty, noop } from 'ramda-extension';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Order from 'components/atoms/CustomSVGIcon/Order';
import MODALS from 'constants/modals';
import { KMP_ORDER_AM } from 'features/common/acl/constants';
import { equalOrThreeDashes } from 'utils';

import CampaignNominationsButtons from './CampaignNominationsButtons';

export const PlanedCampaignsTableRow = ({ campaign = {} }) => {
	const handleOpenOrder = useCallback(() => {
		NiceModal.show(MODALS.order, { campaign });
	}, [campaign]);

	const { fullName, startDate, addMatOrder, orderStartDate, orderEndDate } = campaign;

	const today = new Date();
	const orderNotStarted = isBefore(today, startOfDay(new Date(orderStartDate)));

	const orderInProgress = none(isNilOrEmpty)([orderStartDate, orderEndDate])
		? isWithinInterval(today, {
				start: startOfDay(new Date(orderStartDate)),
				end: endOfDay(new Date(orderEndDate)),
		  })
		: false;

	const daysCount = Math.abs(differenceInDays(new Date(), new Date(startDate)));

	return (
		<TableRow key={campaign.id}>
			<TableCell>{equalOrThreeDashes(fullName)}</TableCell>
			<TableCell className="RightAlignColumn">
				{startDate ? getLabelMessage('common:day', { count: daysCount }) : equalOrThreeDashes()}
			</TableCell>
			<TableCell />
			<TableCell>
				{addMatOrder && orderInProgress && (
					<AccessControl accessLevel={KMP_ORDER_AM}>
						<Tooltip title={getLabelMessage('campaign:addMatOrder')}>
							<IconButton
								sx={{ color: 'primary.main', fontSize: 20, p: 0 }}
								disableRipple
								onClick={orderNotStarted ? noop : handleOpenOrder}
								disabled={orderNotStarted}
							>
								<Order />
							</IconButton>
						</Tooltip>
					</AccessControl>
				)}
			</TableCell>
			<TableCell>
				<CampaignNominationsButtons campaign={campaign} />
			</TableCell>
		</TableRow>
	);
};

PlanedCampaignsTableRow.propTypes = {
	campaign: PropTypes.object,
};

const MemoizedPlannedCampaignsTableRow = React.memo(PlanedCampaignsTableRow);

export default MemoizedPlannedCampaignsTableRow;
